<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
            <!-- <div class="banner_warp">
                <div class="top-text">
                    <p>新闻中心</p>
                    <p>能够及时洞悉公司情况，了解行业发展</p>
                </div>
                <img src="" alt="">
            </div> -->
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>公司动态</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main">
            <p>首次开展合作伙伴公司产品培训</p>

            <p class="con_p" style="margin-bottom: 10px;">
                为了更好的进行业务拓展，司马大大（北京）智能系统有限公司于2019年2月28日，首次开展了对合作伙伴公司相关销售人员/技术人员的产品培训。
            </p>

            <p class="con_p">
                本次的培训内容主要包括VDMS-T-1实时压缩演示、VDMS服务器历史压缩演示、VDMS视频溯源演示等基本培训。 
                培训的方式分为讲解培训和操作培训。讲解培训主要是对各种压缩演示的硬件设备的连接、软件系统的配置、使用相关知识的培训。
                操作培训是培训人员现场根据讲解进行实际操练。
            </p>

            <img src="../../../assets/images/6.png" alt="" class="traimg">
             
            <p class="con_p">
                我公司结合以往的经验，对本次的培训工作进行了认真的设计和细致的规划。培训专辑主要包括：《产品介绍》、《历史压缩软件产品安装培训》
                及实操练习、《VDMS客户端使用说明》、《标准演示操作流程》及实操练习、《系统对接演示》及实操练习。
            </p>
            <p class="con_p">
                本次培训圆满成功，获得参加培训人员的一致好评，为以后的业务拓展打下坚实的基础。
            </p>

        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
     /* height: 681px; */
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }


/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 60px;
}
.publish_main p:nth-child(1) {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 45px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
    margin-bottom: 34px;
}
.publish_main .traimg{
    display: block;
    margin: 0 auto;
    margin-bottom: 80px;
    margin-top: 80px;
}

</style>



// WEBPACK FOOTER //
// src/components/news/training/training.vue